<template>
    <div
        class="nurse-modal"
        v-if="show"
        role="dialog"
        aria-modal="true"
        aria-labelledby="dialogTitle"
        aria-describedby="dialogDesc"
        tabindex="0"
        ref="modal"
        @keydown.tab="trapFocus"
    >
        <div class="nurse-modal-content">
            <button 
                ref="nurseModalClose"
                class="nurse-modal-close"
                @click="close"
                aria-label="Close Nurse Modal"
            >
                <img :src="imageModalClose" alt=""  aria-hidden="true">
            </button>
            <div :class="{'nurse-modal-columns': true, 'no-image': !user.avatar}">
                <div v-if="user.avatar" class="nurse-modal-image">
                    <img :src="user.avatar" :alt="user.display_name + '\'s Avatar'">
                </div>
                <div class="nurse-modal-info">
                    <h2 v-if="user.display_name" id="dialogTitle">{{ user.display_name }}</h2>
                    <div id="dialogDesc">
                        <p class="nurse-modal-info-email" v-if="user.user_email"><span>Email: </span><a :href="`mailto:${ user.user_email }`" target="blank" :aria-label="`${ user.user_email }, opens in a new window`">{{ user.user_email }}</a></p>
                        <p class="nurse-modal-info-phone" v-if="user.phone"><span>Phone: </span><span>{{ user.phone }}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import image_modal_close from '@/images/icon-modal-close.svg';

export default {
    data() {
        return {
            imageModalClose: image_modal_close,
        };
    },
    props: {
        show: Boolean,
        user: Object,
    },
    mounted() {
        document.addEventListener('focusin', this.checkFocus);
    },
    beforeDestroy() {
        document.removeEventListener('focusin', this.checkFocus);
    },
    watch: {
        show(newVal) {
            this.$nextTick(() => {
                if (newVal) {
                    this.$refs.modal.focus();
                } else {
                    // return focus to element that opened dialog
                }
            });
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        checkFocus() {
            if (this.show && !this.$refs.modal.contains(document.activeElement)) {
                this.$refs.modal.focus();
            }
        },
        trapFocus(event) {
            if (this.show) {
                const focusableElements = this.$refs.modal.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
                const firstFocusableEl = focusableElements[0];
                const lastFocusableEl = focusableElements[focusableElements.length - 1];

                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableEl) {
                        event.preventDefault();
                        lastFocusableEl.focus();
                    }
                } else {
                    if (document.activeElement === lastFocusableEl) {
                        event.preventDefault();
                        firstFocusableEl.focus();
                    }
                }
            }
        },
    },
};
</script>

<style scoped>
</style>
